import Header from "./Header";
import { showAlert } from "helper";
import styled from 'styled-components';
import { useDispatch } from "react-redux";
import MapModal from "components/MapModal";
import TextButton from "components/TextButton";
import { MapModalAnnotateStatus } from "constant";
import React, { useState, useEffect } from "react";
import { GetDrawnShape } from '../../../MapView/MapUtils';
import useViewerStore from '../../../../store-zustand/viewer';
import useProjectStore from '../../../../store-zustand/project';
import MarkerSettings from "./AnnotationSettings/MarkerSettings";
import NonMarkerSettings from "./AnnotationSettings/NonMarkerSettings";

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 30px;
`;

const Title = styled.h2`
  color: white;
  margin-bottom: 0 !important;
`;

const SidebarProject = ({ annotation, onClose, closeeditedannotation, onBack, onDelete }) => {
  const { AddAnnotation, project_id, currentAnnotationName, currentAnnotationDescription, setcurrentAnnotationName, setcurrentAnnotationDescription, setcurrentAnnotationIcon, setcurrentAnnotationColor, uploadImage, updateannotationStyle, setcurrentAnnotationId, currentImageToUploadAnnotation, setsingleannotationeidtion, setreloadAnnotationsList, setcurrentAnnotationAlpha, setcurrentAnnotationWidth, setcurrentPinSize } = useProjectStore();
  const { viewer } = useViewerStore();
  const dispatch = useDispatch();
  const [mapModal, setMapModal] = useState({...annotation, status: MapModalAnnotateStatus.Edit});

  const handleChangeField = (fieldName, status) => {
    setMapModal((mapModal) =>
      Object.assign({...mapModal, [fieldName]: status,})
    );
  };

  const handleStatusChange = (status) => {
    handleChangeField("status", status);
  };

  const saveannotation = async () => {
    let keyword = {};
    let hidealerts = false;
    let addannotationtoviewer = true;

    if (window['CurrentPinMarker']) {
      if (window.hasOwnProperty('CurrentPointCentroid') & window.hasOwnProperty('CurrentPointCentroidArrayFormat')) {
        let lon = window.CurrentPointCentroidArrayFormat[0];
        let lat = window.CurrentPointCentroidArrayFormat[1];
        let height = window.CurrentPointCentroidArrayFormat[2];
        let shapeString = `POINT(${lon} ${lat} ${height})`;
        keyword.annotationGeometry = shapeString;
        keyword.annotationName = currentAnnotationName || 'Untitled Pin';
        keyword.annotationDescription = currentAnnotationDescription || window['CurrentPointCentroid'];
        keyword.annotationType = 'Point';
        keyword.annotationCentroid = window['CurrentPointCentroid'];
        let measurementValue = window['currentPinHeight'];
        let actualMeasurementvalue = window['currentPinHeight'];
        let measurementUnit = "m"
        let actualMeasurementUnit = "m"
        keyword.annotationInMeter = `${measurementValue} ${measurementUnit}`;
        keyword.annotationMeasurement = actualMeasurementvalue
        keyword.annotationMeasurementUnit = actualMeasurementUnit
        keyword.projectId = project_id;
        let defaultStyle = `{
          "FillColor": "#487BF2",
          "LineFillTransparency": 1,
          "PolygonFillTransparency": 0.35,
          "LineWidth": 3,
          "PinName": "defaultMarker.svg",
          "pinwidth": ${window['CurrentPinMarker'].pinwidth},
          "pinheight": ${window['CurrentPinMarker'].pinheight},
          "PinColor": "${window['CurrentPinMarker'].PinColor.toCssHexString()}",
          "PinMarker":"${window['CurrentPinMarker'].PinMarker}",
          "Labelfontsize": "11px",
          "LabelfillColor": "#FFFFFF",
          "LabelVisibility": false,
          "Polygonoutlinecolor": "#3B6DBD"
        }`

        keyword.annotationStyle = defaultStyle;
        const response = await AddAnnotation(keyword);
        if (response.length === 0) {
          if (hidealerts === false) {
            alert('Error while saving Pin Annotation');
          }
          else {
            return 'Error';
          }
        }
        else {
          if (hidealerts === false) {
            showAlert('success', 'Annotation saved successfully!');
          }
          delete window['CurrentPointCentroid'];
          delete window['CurrentPointCentroidArrayFormat'];
          viewer.scene.primitives.remove(window['CurrentPinMarker']);
          delete window['CurrentPinMarker'];

          setcurrentAnnotationName('');
          setcurrentAnnotationDescription();
          setcurrentAnnotationIcon();
          setcurrentAnnotationColor();
          setcurrentAnnotationAlpha();
          setcurrentPinSize();
          setcurrentAnnotationWidth();
          dispatch({ type: 'SET_PROJECT_PANEL', panel: 'Single' });
          if (addannotationtoviewer) {
            setcurrentAnnotationId(response);
          }

          if (hidealerts === true) {
            return response;
          }
        }

      } else {
        if (hidealerts === false) {
          alert('An error Occured while saving New annotation');
        } else {
          return 'Error';
        }
      }
    } else if (window.hasOwnProperty('CurrentMeasureShape')) {
      let keyword = {};
      let geometryType = window.CurrentMeasureShape['GeometryType'];
      let shapeString = GetDrawnShape('CurrentMeasureShape', viewer);
      keyword.annotationGeometry = shapeString;
      keyword.annotationType = geometryType;      
      keyword.annotationName = currentAnnotationName ? currentAnnotationName : keyword.annotationType === 'POLYLINE' ? 'Untitled Line' : 'Untitled Area';
      keyword.annotationDescription = currentAnnotationDescription || "";
      keyword.annotationCentroid = window['CurrentPolygonCentroid'];
      
      let measurementUnit = 'm';
      let actualMeasurementUnit = 'm';
      let measurementValue = window['CurrentDistanceLeftMouse'];
      let actualMeasurementvalue = window['CurrentDistanceLeftMouse'];
      if (geometryType === 'POLYGON') {
        measurementUnit = 'm²';
        measurementValue = window['CurrentPolygonArea'];
        actualMeasurementvalue = window['CurrentPolygonArea'];
      }
      keyword.annotationInMeter = `${measurementValue} ${measurementUnit}`;
      keyword.annotationMeasurement = actualMeasurementvalue
      if (measurementUnit === 'm²') {
        keyword.annotationMeasurementUnit = `${actualMeasurementUnit}²`
      } else {
        keyword.annotationMeasurementUnit = actualMeasurementUnit
      }

      keyword.projectId = project_id;
      let defaultStyle = `{
        "FillColor": "${window.activeShape.FillColor.toCssHexString()}",
        "LineFillTransparency": ${window.activeShape.LineFillTransparency},
        "PolygonFillTransparency": ${window.activeShape.PolygonFillTransparency || '0.35'},
        "LineWidth": ${window.activeShape.LineWidth},
        "PinName": "defaultMarker.svg",
        "pinwidth": 30,
        "pinheight": 30,
        "PinColor": "#487BF2",
        "PinMarker":"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxnIGlkPSJtYXJrZXJfc2ltcGxlX2xhcmdlIj4NCjxnIGlkPSIjYW5ub3RhdGlvbi1tYXJrZXIiPg0KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTQ2LjI1IDI1LjVDNDYuMjUgMzEuOTI1IDQxIDM5Ljk3NSAzMC44NSA0OS4yNzVMMzAgNTAuMDI1TDI5LjE1IDQ5LjI1QzE5IDM5Ljk3NSAxMy43NSAzMS45MjUgMTMuNzUgMjUuNUMxMy43NSAxNS45IDIwLjggOC43NSAzMCA4Ljc1QzM5LjIgOC43NSA0Ni4yNSAxNS44NzUgNDYuMjUgMjUuNVoiIGZpbGw9IndoaXRlIi8+DQo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0zMCA1QzQwLjUgNSA1MCAxMy4wNSA1MCAyNS41QzUwIDMzLjggNDMuMzI1IDQzLjYyNSAzMCA1NUMxNi42NzUgNDMuNjI1IDEwIDMzLjggMTAgMjUuNUMxMCAxMy4wNSAxOS41IDUgMzAgNVpNNDUgMjUuNUM0NSAxNi40MjUgMzguMzc1IDEwIDMwIDEwQzIxLjYyNSAxMCAxNSAxNi40MjUgMTUgMjUuNUMxNSAzMS4zNSAxOS44NzUgMzkuMSAzMCA0OC4zNUM0MC4xMjUgMzkuMSA0NSAzMS4zNSA0NSAyNS41Wk0zMCAzMEMyNy4yNSAzMCAyNSAyNy43NSAyNSAyNUMyNSAyMi4yNSAyNy4yNSAyMCAzMCAyMEMzMi43NSAyMCAzNSAyMi4yNSAzNSAyNUMzNSAyNy43NSAzMi43NSAzMCAzMCAzMFoiIGZpbGw9IiM0ODdCRjIiLz4NCjwvZz4NCjwvZz4NCjwvc3ZnPg0K",
        "Labelfontsize": "11px",
        "LabelfillColor": "#FFFFFF",
        "LabelVisibility": false,
        "Polygonoutlinecolor": "${window.activeShape.Polygonoutlinecolor.toCssHexString()}"
      }`

      keyword.annotationStyle = defaultStyle;
      const response = await AddAnnotation(keyword);
      if (response.length === 0 || response === 'Error') {
        if (hidealerts === false) {
          alert('Error while saving Annotation');
        } else {
          return 'Error';
        }
      } else {
        if (hidealerts === false) {
          showAlert('success', 'Annotation saved successfully!');
        }

        viewer.entities.remove(window.floatingPoint);
        viewer.entities.remove(window.activeShape);
        window.lineNodes.forEach((obj, index) => { viewer.entities.remove(obj) })
        window.activeShapePoints = [];
        delete (window.activeShapePoints);
        delete (window.Shapepoints);
        delete (window.activeShape);
        delete (window.lineNodes);
        delete (window.floatingPoint);
        window.taskingFeaturesArray.forEach((obj, index) => { viewer.entities.remove(obj) })
        window.taskingFeaturesArray = [];

        setcurrentAnnotationName('');
        setcurrentAnnotationDescription();
        setcurrentAnnotationIcon();
        setcurrentAnnotationColor();
        setcurrentAnnotationAlpha();
        setcurrentPinSize();
        setcurrentAnnotationWidth();
        dispatch({ type: 'SET_PROJECT_PANEL', panel: 'Single' });
        viewer.scene.screenSpaceCameraController.enableRotate = true;
        if (addannotationtoviewer) {
          setcurrentAnnotationId(response);
        }

        if (hidealerts === true) return response;
      }

    } else {
      setsingleannotationeidtion(undefined);
      let copy = Object.assign({}, window.annotationObj[window.actualAnnotationId]);
      keyword.annotationID = copy.Idannotation;
      keyword.style = copy;
      keyword.annotationname = currentAnnotationName;
      keyword.annotationdescription = currentAnnotationDescription;
      keyword.style.FillColor = keyword.style.FillColor.toCssHexString();
      keyword.style.PinColor = keyword.style.PinColor.toCssHexString();
      keyword.style.LabelfillColor = keyword.style.LabelfillColor.toCssHexString();
      keyword.style.Polygonoutlinecolor = keyword.style.Polygonoutlinecolor.toCssHexString();
      keyword.style = JSON.stringify(keyword.style);

      let annotationStyle = await updateannotationStyle(keyword);
      if (annotationStyle !== 'error') {

        setreloadAnnotationsList(parseInt(annotationStyle) + Math.floor(Math.random() * 1000) + 1);
        if (currentImageToUploadAnnotation !== undefined) {
          let currentImage = currentImageToUploadAnnotation;
          let formData = new FormData();
          formData.append("image", currentImage);
          formData.append("annotationID", keyword.annotationID);
          let UploadedImage = await uploadImage(formData, keyword);
          if (UploadedImage === 'error') alert('Erro while uploading image');
        }
        closeeditedannotation();
      } else {
        alert('Error while updating style');
      }
    }
  }

  useEffect(() => {
    if (annotation && annotation.annotationId) {
      dispatch({ type: 'TOGGLE_MAP_MODAL', show: true });
    } else {
      dispatch({ type: 'TOGGLE_MAP_MODAL', show: false });
    }
  }, [annotation])

  return (
    <>
      <Header onClose={onClose} onBack={onBack} onDelete={onDelete} deleteDisabled={annotation.annotationId === undefined} />
      <TitleSection>
        <Title>Settings</Title>
        <TextButton text="Save" onClick={saveannotation} />
      </TitleSection>
      {annotation.type === "Marker" ? <MarkerSettings annotation={annotation} /> : <NonMarkerSettings annotation={annotation} />}
      {annotation && (
        <MapModal
          type={mapModal.type}
          info={mapModal}
          status={mapModal.status}
          onChangeStatus={handleStatusChange}
          onChangeDimension={(dimension) => handleChangeField("dimension", dimension)}
          onclose={() => { closeeditedannotation() }}
          backtoProjectModalView={() => {closeeditedannotation() }}
        />
      )}
    </>
  );
};

export default SidebarProject;